function flexible() {
  const docEl = document.documentElement
  const dpr = window.devicePixelRatio || 1

  // adjust body font size
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = 12 * dpr + 'px'
    } else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize()

  const getVh = () => {
    return (window.visualViewport?.height || window.innerHeight) * 0.01
  }

  // 设置 CSS 变量 --vh
  function setVh(tempVh?: number) {
    const vh = tempVh || getVh()
    docEl.style.setProperty('--vh', `${vh}px`)
  }

  // set 1rem = viewWidth / 10
  function setRemUnit() {
    const isPortrait = window.matchMedia('(orientation: portrait)').matches
    // 旋转方向, 兼容性问题，暂时不使用
    // const orientationType = screen?.orientation?.type
    // 临时做兼容，防止页面跳动，300ms后修正
    setVh(screen.height / 100)
    setTimeout(() => {
      setVh()
    }, 300)
    const deviceOrientation = isPortrait ? 'portrait' : 'landscape'
    const rem = (isPortrait ? docEl.clientWidth : Math.min(screen.width, screen.height)) / 10
    docEl.style.fontSize = rem + 'px'
    // 设置根节点样式
    ;[...docEl.classList]?.forEach((item) => {
      if (/^app-.*-mode$/.test(item)) {
        docEl.classList.remove(item)
      }
    })
    docEl.classList.add(`app-${deviceOrientation}-mode`)
    // docEl.classList.add(`app-${orientationType}-mode`)
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    const fakeBody = document.createElement('body')
    const testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}

export default flexible
